export enum DocumentStatusEnum {
  /// <summary>
  /// Tất cả các trạng thái
  /// </summary>
  All = 0,

  /// <summary>
  /// Gửi hồ sơ
  /// </summary>
  Send = 1,

  /// <summary>
  /// Nhận hồ sơ
  /// </summary>
  Received = 2,

  /// <summary>
  /// Đã duyệt xoá định danh
  /// </summary>
  ApprovedDeleteId = 3,

  /// <summary>
  ///  Đã duyệt trích xuất thông tin
  /// </summary>
  ApprovedExtractInfo = 4,

  /// <summary>
  /// Yêu cầu bổ sung hồ sơ
  /// </summary>
  RequestAddProfile = 5,

  /// <summary>
  /// Đã bổ sung hồ sơ
  /// </summary>
  ProfileAdded = 6,

  /// <summary>
  /// Đề xuất phương án bồi thường
  /// </summary>
  ProposeCompensationPlan = 7,

  /// <summary>
  /// Trình lãnh đạo phê duyệt
  /// </summary>
  SendLeader = 8,

  /// <summary>
  /// Gửi đề xuất cho công ty BH
  /// </summary>
  SendInsuranceCompany = 9,

  /// <summary>
  /// Đã duyệt hồ sơ bồi thường
  /// </summary>
  Approved = 10,

  /// <summary>
  /// CTBH yêu cầu bổ sung hồ sơ
  /// </summary>
  InsuranceCompanyRequestAddProfile = 11,

  /// <summary>
  /// CTBH phê duyệt
  /// </summary>
  InsuranceCompanyApproved = 12,

  /// <summary>
  /// Thông báo cho bệnh nhân
  /// </summary>
  NotifyPatient = 13,

  /// <summary>
  /// Đã chi trả
  /// </summary>
  Paid = 14,

  /// <summary>
  /// Đang xử lý duyệt lại hồ sơ
  /// </summary>
  Review = 15,

  /// <summary>
  /// Đã duyệt lại hồ sơ
  /// </summary>
  ProfileReviewed = 16,

  /// <summary>
  /// Bị từ chối
  /// </summary>
  Refuse = 17,

  /// <summary>
  /// Đóng hồ sơ
  /// </summary>
  Close = 18,

  /// <summary>
  ///  Đã duyệt nội dung y khoa
  /// </summary>
  ApprovedMedical = 19,

  /// <summary>
  ///  Hủy xử lý
  /// </summary>
  Cancel = 20,
}

export enum DocumentProcessingStatusEnum {
  /// <summary>
  /// Tất cả các trạng thái
  /// </summary>
  All = 0,

  /// <summary>
  /// Cần bổ sung
  /// </summary>
  Supplement = 1,

  /// <summary>
  /// Đang xử lý
  /// </summary>
  Processing = 2,

  /// <summary>
  /// Đã xử lý
  /// </summary>
  Processed = 3,

  /// <summary>
  /// Đóng hồ sơ
  /// </summary>
  Close = 4,

  /// <summary>
  /// Bị từ chối
  /// </summary>
  Refuse = 5,
}

export const DocumentStatusObjectEnum: { [key: number]: object } = {
  0: {
    title: "Tất cả",
    badge: "secondary",
    icon: "",
    background: "#F0F0F0",
    color: "#000000",
  },
  1: {
    title: "Gửi chờ xử lý",
    badge: "secondary",
    icon: "notepad-edit",
    background: "#FFEE93",
    color: "#5A4B00",
  },
  2: {
    title: "Nhận hồ sơ",
    badge: "primary",
    icon: "arrow-up",
    background: "#90CAF9",
    color: "#0A3C6E",
  },
  3: {
    title: "Duyệt xoá định danh",
    badge: "primary",
    icon: "arrow-down",
    background: "rgb(42 247 208)",
    color: "#000000",
  },
  4: {
    title: "Duyệt trích xuất thông tin",
    badge: "primary",
    icon: "arrow-circle-left",
    background: "#A5D6A7",
    color: "#1B5E20",
  },
  5: {
    title: "Yêu cầu bổ sung hồ sơ",
    badge: "primary",
    icon: "exit-up",
    background: "#FFE082",
    color: "#5D3B00",
  },
  6: {
    title: "Đã bổ sung hồ sơ",
    badge: "primary",
    icon: "exit-down",
    background: "#81D4FA",
    color: "#014D6E",
  },
  7: {
    title: "Đề xuất PA bồi thường",
    badge: "primary",
    icon: "arrow-circle-left",
    background: "#C5CAE9",
    color: "#1A237E",
  },
  8: {
    title: "Trình lãnh đạo phê duyệt",
    badge: "primary",
    icon: "arrow-up-right",
    background: "#a3e4d7",
    color: "#000000",
  },
  9: {
    title: "Gửi đề xuất cho CTBH",
    badge: "info",
    icon: "exit-down",
    background: "#4FC3F7",
    color: "#003A4E",
  },
  10: {
    title: "Đã duyệt bồi thường",
    badge: "success",
    icon: "shield-tick",
    background: "#81C784",
    color: "#ffffff",
  },
  11: {
    title: "CTBH yêu cầu bổ sung HS",
    badge: "danger",
    icon: "shield-cross",
    background: "#FFD54F",
    color: "#5D4300",
  },
  12: {
    title: "CTBH phê duyệt",
    badge: "dark",
    icon: "trash",
    background: "#CFD8DC",
    color: "#263238",
  },
  13: {
    title: "Thông báo cho bệnh nhân",
    badge: "warning",
    icon: "arrow-circle-left ",
    background: "#FFCC80",
    color: "#5D3100",
  },
  14: {
    title: "Đã chi trả",
    badge: "warning",
    icon: "arrow-circle-left ",
    background: "#7239ea",
    color: "#ffffff",
  },
  15: {
    title: "Đang xử lý duyệt lại hồ sơ",
    badge: "warning",
    icon: "arrow-circle-left ",
    background: "#FFB74D",
    color: "#5E3C00",
  },
  16: {
    title: "Đã duyệt lại hồ sơ",
    badge: "warning",
    icon: "arrow-circle-left ",
    background: "#FFE57F",
    color: "#5C4600",
  },
  17: {
    title: "Từ chối",
    badge: "dark",
    icon: "arrow-circle-left ",
    background: "#FF8A80",
    color: "#650000",
  },
  18: {
    title: "Đã đóng",
    badge: "warning",
    icon: "arrow-circle-left ",
    background: "#FFF9C4",
    color: "#5C5500",
  },
  19: {
    title: "Đã duyệt nội dung y khoa",
    badge: "warning",
    icon: "arrow-circle-left ",
    background: "#C8E6C9",
    color: "#1B5E20",
  },
  20: {
    title: "Hủy xử lý",
    badge: "warning",
    icon: "arrow-circle-left ",
    background: "#F8BBD0",
    color: "#880E4F",
  },
};
export const DocumentProcessingStatusObjectEnum: { [key: number]: object } = {
  0: {
    title: "Tất cả",
    badge: "secondary",
    icon: "",
  },
  /// <summary>
  /// Gửi chờ xử lý
  /// </summary>
  1: {
    title: "Cần bổ sung",
    badge: "warning",
    icon: "notepad-edit",
  },
  /// <summary>
  /// Đang xử lý
  /// </summary>
  2: {
    title: "Đang xử lý",
    badge: "info",
    icon: "arrow-up",
  },
  /// <summary>
  ///  Đã xử lý
  /// </summary>
  3: {
    title: "Đã xử lý",
    badge: "primary",
    icon: "arrow-down",
  },
  /// <summary>
  /// Đóng hồ sơ
  /// </summary>
  4: {
    title: "Đóng hồ sơ",
    badge: "success",
    icon: "arrow-circle-left",
  },
  /// <summary>
  /// Bị từ chối
  /// </summary>
  5: {
    title: "Bị từ chối",
    badge: "danger",
    icon: "exit-up",
  },
};

export enum PermissonEnum {
  ///Xem
  Read = 1,

  ///Viết
  Create = 2,

  ///Sửa
  Update = 4,

  ///Xóa
  Delete = 8,

  ///Biên tập
  Editing = 16,

  ///Duyệt nội dung y khoa
  Medical = 32,

  ///Quyền lãnh đạo
  Manage = 64,

  ///Gửi Tổng Biên Tập
  SendTBT = 128,

  ///Tổng Biên Tập
  TBT = 256,

  ///Cài đặt
  Setting = 1024,

  ///Toàn quyền chức năng
  Full = 1073741824,

  ///None
  Allow = 34359738368,
}

export enum ModuleEnum {
  Document = 1,
  Category = 2,
  InsuranceCompany = 3,
  MedicalFacility = 4,
  PaymentRequest = 5,
  OriginalDocument = 6,
  Customer = 7,
  Contract = 8,
  UserReport = 9, //Báo cáo hiệu suất của nhân viên
  DocumentPending = 10,
  Chat = 11,
  ActivityLog = 12,
  Role = 98,
  User = 99,
}

export enum FileFormType {
  "FormType.PRESCRIPTION" = "Đơn thuốc",
  "FormType.PRESCRIPTION_FV" = "Đơn thuốc",
  "FormType.MEDICAL_SLIP" = "Bảng kê",
  "FormType.VAT_INVOICE" = "Hóa đơn giá trị gia tăng",
  "FormType.SALES_INVOICE" = "Hóa đơn bán hàng",
  "FormType.RECEIPT_VOUCHER" = "Biên lai / Phiếu thu",
  "FormType.MEDICINE_SLIP" = "Phiếu bán thuốc",
  "FormType.MEDICAL_ORDER" = "Chỉ định cận lâm sàng",
  "FormType.MEDICAL_EXAMINATION" = "Phiếu khám bệnh",
  "FormType.MEDICAL_DISCHARGE" = "Giấy ra viện",
  "FormType.MEDICAL_SUMMARY" = "Tóm tắt bệnh án",
  "FormType.MEDICAL_SURGERY_CERT" = "Giấy chứng nhận phẫu thuật",
  "FormType.LAB_TEST_REPORT" = "Kết quả xét nghiệm",
  "FormType.IMAGING_REPORT" = "Kết quả chẩn đoán hình ảnh",
  "FormType.UNKNOWN" = "Không xác định",
  "FormType.OTHER" = "Không xác định",
  "FormType.UNCLASSIFIABLE_FORM" = "Không xác định",
}
export enum ExpenseCategory {
  "ExpenseCategory.EXAMINATION" = "Khám bệnh",
  "ExpenseCategory.BED_DAYS" = "Ngày giường",
  "ExpenseCategory.PARACLINICAL_SERVICES" = "Dịch vụ cận lâm sàng (XN, CĐHA, TDCN)",
  "ExpenseCategory.SURGERY_PROCEDURES" = "Phẫu thuật, thủ thuật",
  "ExpenseCategory.MEDICATIONS" = "Thuốc",
  "ExpenseCategory.DIETARY_SUPPLEMENTS" = "Thực phẩm chức năng",
  "ExpenseCategory.OTHERS" = "Khác",
}
